import { Users, Activity, MapPin, Timer, Clock } from "lucide-react";
import { formatDuration } from "./utils";

const StatsCards = ({ globalStats }) => (
  <div className="reid-stats-grid">
    <div className="reid-stats-card reid-stats-card-blue">
      <div className="reid-stats-card-content">
        <div>
          <p className="reid-stats-card-label">Total REIDs</p>
          <p className="reid-stats-card-value">{globalStats.totalReids}</p>
        </div>
        <Users className="reid-icon-xl" />
      </div>
    </div>

    <div className="reid-stats-card reid-stats-card-green">
      <div className="reid-stats-card-content">
        <div>
          <p className="reid-stats-card-label">Total Events</p>
          <p className="reid-stats-card-value">{globalStats.totalJourneys}</p>
        </div>
        <Activity className="reid-icon-xl" />
      </div>
    </div>

    <div className="reid-stats-card reid-stats-card-purple">
      <div className="reid-stats-card-content">
        <div>
          <p className="reid-stats-card-label">Unique Zones</p>
          <p className="reid-stats-card-value">{globalStats.uniqueZones}</p>
        </div>
        <MapPin className="reid-icon-xl" />
      </div>
    </div>

    <div className="reid-stats-card reid-stats-card-orange">
      <div className="reid-stats-card-content">
        <div>
          <p className="reid-stats-card-label">Total Dwell</p>
          <p className="reid-stats-card-value-large">
            {formatDuration(globalStats.totalDwellTime)}
          </p>
        </div>
        <Timer className="reid-icon-xl" />
      </div>
    </div>

    <div className="reid-stats-card reid-stats-card-teal">
      <div className="reid-stats-card-content">
        <div>
          <p className="reid-stats-card-label">Avg Dwell</p>
          <p className="reid-stats-card-value-large">
            {formatDuration(globalStats.avgDwellTime)}
          </p>
        </div>
        <Clock className="reid-icon-xl" />
      </div>
    </div>
  </div>
);

export default StatsCards; 